import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import { namespaces } from '../../i18n/i18n.constants';
import { setSessionId } from '../../redux/modules/reducer';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import { ObjectType } from '../../types/objectType';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import uuidButtonStyle from './uuidButtonStyle';

export const UuidButton = () => {
  const classes = uuidButtonStyle();
  const dispatch = useDispatch();
  const { externalParams } = useSelector((store: ObjectType) => store.appReducer);
  const generateUuid = () => {
    const uuid = uuidv4()
    dispatch(setSessionId(uuid));
    navigator.clipboard.writeText(uuid);
  };
  const { t } = useTranslation(namespaces.common);

  return (
    <div
      className={classes.align}
      style={{
        flexDirection: 'column',
        display: 'flex',
        alignItems: 'end',
        height: '80px'
      }}>
      < Button

        onClick={generateUuid}
        variant="outlined"
        startIcon={<ContentCopyIcon />}
      >
        {t('utils.generateUuid')}
      </Button>
      <span
        className={classes.uuid}
      /* style={{
        display: 'block',
        fontSize: '11px',
        textAlign: 'right'
      }} */
      >{externalParams.sessionId}</span>
    </div>
  );
};
